
import store from 'store';
import Config from '@/config';

const RISK_FILES_NOTIFIED_OPINIONS_ID_KEY = `pegasus_${Config.COUNTRY_CODE}/risk_files_notified_opinions_id`;

export const getNotifiedOpinionsId = () => store.get(RISK_FILES_NOTIFIED_OPINIONS_ID_KEY) || [];

export const setNotifiedOpinionsId = (opinionsId) => store.set(RISK_FILES_NOTIFIED_OPINIONS_ID_KEY, opinionsId);
